/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AddInternationalLicensingPaymentRequestBody,
  AddInternationalLicensingPaymentRequestBodyToJSON,
  AddInternationalLicensingPaymentResponse,
  AddInternationalLicensingPaymentResponseFromJSON,
  Address,
  AddressToJSON,
  FetchBillingResponse,
  FetchBillingResponseFromJSON,
  FetchCountryCoordinatorLicensingDetailsResponse,
  FetchCountryCoordinatorLicensingDetailsResponseFromJSON,
  FetchCountryCoordinatorTotalBalanceResponse,
  FetchCountryCoordinatorTotalBalanceResponseFromJSON,
  FetchInternationalLicensingFilterOptionsResponse,
  FetchInternationalLicensingFilterOptionsResponseFromJSON,
  FetchLcdTotalOwedResponse,
  FetchLcdTotalOwedResponseFromJSON,
  FetchLicensedDirectorBillingDetailsResponse,
  FetchLicensedDirectorBillingDetailsResponseFromJSON,
  FetchLicensingInternationalPaymentsResponse,
  FetchLicensingInternationalPaymentsResponseFromJSON,
  FetchLicensingLcdPaymentsResponse,
  FetchLicensingLcdPaymentsResponseFromJSON,
  OK,
  OKFromJSON,
  PayByAchRequestBody,
  PayByAchRequestBodyToJSON,
  Payment,
  PaymentOptions,
  PaymentOptionsFromJSON,
  PaymentResponse,
  PaymentResponseFromJSON,
  PaymentStartRequestBody,
  PaymentStartRequestBodyToJSON,
  PaymentToJSON,
  ValidateAchRoutingNumber,
  ValidateAchRoutingNumberFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface AddInternationalLicensingPaymentRequest
  extends runtime.BaseRequestParameters {
  body: AddInternationalLicensingPaymentRequestBody
}

export interface DeletePaymentRequest extends runtime.BaseRequestParameters {
  paymentKey: number
}

export interface FetchBillingRequest extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  userKey?: number
  generateReport?: boolean
  actorKey?: number
  communityKey?: number
  programTypeKey?: FetchBillingProgramTypeKeyEnum
  directorKey?: number
}

export interface FetchCountryCoordinatorLicensingDetailsRequest
  extends runtime.BaseRequestParameters {
  programKey: number
}

export interface FetchCountryCoordinatorTotalBalanceRequest
  extends runtime.BaseRequestParameters {
  actorKey?: number
}

export interface FetchEnrollmentBillingPaymentOptionsRequest
  extends runtime.BaseRequestParameters {}

export interface FetchInternationalLicensingFilterOptionsRequest
  extends runtime.BaseRequestParameters {
  actorKey: number
  communityName?: string
  actorName?: string
}

export interface FetchLcdTotalOwedRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  userKey?: number
  generateReport?: boolean
  actorKey?: number
}

export interface FetchLicensedDirectorBillingDetailsRequest
  extends runtime.BaseRequestParameters {
  programKey: number
  actorKey?: number
}

export interface FetchLicensingInternationalPaymentsRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  userKey?: number
  generateReport?: boolean
  actorKey?: number
}

export interface FetchLicensingLcdPaymentsRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  userKey?: number
  generateReport?: boolean
  actorKey?: number
  date?: string
  program?: string
}

export interface FetchPaymentOptionsRequest
  extends runtime.BaseRequestParameters {
  userKey: number
}

export interface PayByAchRequest extends runtime.BaseRequestParameters {
  paymentKey: number
  body: PayByAchRequestBody
}

export interface StartPaymentRequest extends runtime.BaseRequestParameters {
  body: PaymentStartRequestBody
  userKey?: number
  generateReport?: boolean
  actorKey?: number
}

export interface UpdateLicensingInternationalPaymentRequest
  extends runtime.BaseRequestParameters {
  paymentKey: number
  body?: Payment
}

export interface UpdatePaymentRequest extends runtime.BaseRequestParameters {
  body?: Payment
}

export interface UpdatePaymentAddressRequest
  extends runtime.BaseRequestParameters {
  paymentKey: number
  body: Address
}

export interface ValidateAchRoutingNumberRequest
  extends runtime.BaseRequestParameters {
  routingNumber: string
}

/**
 * PaymentsApi - interface
 *
 * @export
 * @interface PaymentsApiInterface
 */
export interface PaymentsApiInterface {
  /**
   * Adds a payment to the international licensing account for the the requested userKey
   * @summary Adds a payment to the international licensing account for the the requested userKey
   * @param {AddInternationalLicensingPaymentRequestBody} addInternationalLicensingPaymentRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  addInternationalLicensingPaymentRaw(
    requestParameters: AddInternationalLicensingPaymentRequest
  ): Promise<runtime.ApiResponse<AddInternationalLicensingPaymentResponse>>

  /**
   * Adds a payment to the international licensing account for the the requested userKey
   * Adds a payment to the international licensing account for the the requested userKey
   */
  addInternationalLicensingPayment(
    requestParameters: AddInternationalLicensingPaymentRequest
  ): Promise<AddInternationalLicensingPaymentResponse>

  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * @summary Delete a manually entered payment by paymentKey
   * @param {number} paymentKey The payment key that will use to perform the payment delete action.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  deletePaymentRaw(
    requestParameters: DeletePaymentRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * Delete a manually entered payment by paymentKey
   */
  deletePayment(requestParameters: DeletePaymentRequest): Promise<void>

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * @summary Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [userKey] Unique identifier for the user account.
   * @param {boolean} [generateReport] Flag to indicate if a record should be updated or created in jsonReportData table
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {number} [communityKey] The unique identifier for the community to filter the billing records.
   * @param {'Foundations' | 'Scribblers' | 'Essentials' | 'Challenge A' | 'Challenge B' | 'Challenge I' | 'Challenge II' | 'Challenge III' | 'Challenge IV'} [programTypeKey] The unique identifier for the program type to filter the billing records.
   * @param {number} [directorKey] The unique identifier for the director actor key to filter the billing records.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchBillingRaw(
    requestParameters: FetchBillingRequest
  ): Promise<runtime.ApiResponse<FetchBillingResponse>>

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   */
  fetchBilling(
    requestParameters: FetchBillingRequest
  ): Promise<FetchBillingResponse>

  /**
   * Fetch licensing details for a requested program
   * @summary Fetch licensing details for a requested program
   * @param {number} programKey Unique identifier for the requested program.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchCountryCoordinatorLicensingDetailsRaw(
    requestParameters: FetchCountryCoordinatorLicensingDetailsRequest
  ): Promise<
    runtime.ApiResponse<FetchCountryCoordinatorLicensingDetailsResponse>
  >

  /**
   * Fetch licensing details for a requested program
   * Fetch licensing details for a requested program
   */
  fetchCountryCoordinatorLicensingDetails(
    requestParameters: FetchCountryCoordinatorLicensingDetailsRequest
  ): Promise<FetchCountryCoordinatorLicensingDetailsResponse>

  /**
   * Calculates the total balance owed by the current user acting as a Country Coordinator or the requester actorKey
   * @summary Calculates the total balance owed by the Country Coordinator across all managed communities
   * @param {number} [actorKey] Unique identifier for the requested actor.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchCountryCoordinatorTotalBalanceRaw(
    requestParameters: FetchCountryCoordinatorTotalBalanceRequest
  ): Promise<runtime.ApiResponse<FetchCountryCoordinatorTotalBalanceResponse>>

  /**
   * Calculates the total balance owed by the current user acting as a Country Coordinator or the requester actorKey
   * Calculates the total balance owed by the Country Coordinator across all managed communities
   */
  fetchCountryCoordinatorTotalBalance(
    requestParameters: FetchCountryCoordinatorTotalBalanceRequest
  ): Promise<FetchCountryCoordinatorTotalBalanceResponse>

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * @summary Returns the options needed for parents to complete paying their enrollment(s).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchEnrollmentBillingPaymentOptionsRaw(
    requestParameters: FetchEnrollmentBillingPaymentOptionsRequest
  ): Promise<runtime.ApiResponse<OK>>

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * Returns the options needed for parents to complete paying their enrollment(s).
   */
  fetchEnrollmentBillingPaymentOptions(): Promise<OK>

  /**
   * Retrieve the available filter options to allow filter selection for the licensing billing endpoint.      At a minimum, the community or actors search values should be 3 characters. Provided params filter each response      by the name only.
   * @summary Fetch filter options for licensing billing responses.
   * @param {number} actorKey Unique identifier for the actor managing the community or director, used for lookup by name
   * @param {string} [communityName] Community name to look up
   * @param {string} [actorName] Actor name to look up
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchInternationalLicensingFilterOptionsRaw(
    requestParameters: FetchInternationalLicensingFilterOptionsRequest
  ): Promise<
    runtime.ApiResponse<FetchInternationalLicensingFilterOptionsResponse>
  >

  /**
   * Retrieve the available filter options to allow filter selection for the licensing billing endpoint.      At a minimum, the community or actors search values should be 3 characters. Provided params filter each response      by the name only.
   * Fetch filter options for licensing billing responses.
   */
  fetchInternationalLicensingFilterOptions(
    requestParameters: FetchInternationalLicensingFilterOptionsRequest
  ): Promise<FetchInternationalLicensingFilterOptionsResponse>

  /**
   *      This endpoint retrieves the total licensing balance and due amounts for all programs associated with the logged-in actor.     It provides a comprehensive summary of the current balance and due payments across the programs.
   * @summary Fetch the total licensing balance and due amounts across programs for the logged in LCD.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [userKey] Unique identifier for the user account.
   * @param {boolean} [generateReport] Flag to indicate if a record should be updated or created in jsonReportData table
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchLcdTotalOwedRaw(
    requestParameters: FetchLcdTotalOwedRequest
  ): Promise<runtime.ApiResponse<FetchLcdTotalOwedResponse>>

  /**
   *      This endpoint retrieves the total licensing balance and due amounts for all programs associated with the logged-in actor.     It provides a comprehensive summary of the current balance and due payments across the programs.
   * Fetch the total licensing balance and due amounts across programs for the logged in LCD.
   */
  fetchLcdTotalOwed(
    requestParameters: FetchLcdTotalOwedRequest
  ): Promise<FetchLcdTotalOwedResponse>

  /**
   * Fetch billing details for a licensed community director in a program
   * @summary Fetch billing details for a licensed community director in a program
   * @param {number} programKey Unique identifier for the requested program.
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchLicensedDirectorBillingDetailsRaw(
    requestParameters: FetchLicensedDirectorBillingDetailsRequest
  ): Promise<runtime.ApiResponse<FetchLicensedDirectorBillingDetailsResponse>>

  /**
   * Fetch billing details for a licensed community director in a program
   * Fetch billing details for a licensed community director in a program
   */
  fetchLicensedDirectorBillingDetails(
    requestParameters: FetchLicensedDirectorBillingDetailsRequest
  ): Promise<FetchLicensedDirectorBillingDetailsResponse>

  /**
   *
   * @summary Fetch licensing international payments for all country coordinator roles associated with the provide userId,    or for a specific country coordinator role if an actorKey is provided
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [userKey] Unique identifier for the user account.
   * @param {boolean} [generateReport] Flag to indicate if a record should be updated or created in jsonReportData table
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchLicensingInternationalPaymentsRaw(
    requestParameters: FetchLicensingInternationalPaymentsRequest
  ): Promise<runtime.ApiResponse<FetchLicensingInternationalPaymentsResponse>>

  /**
   * Fetch licensing international payments for all country coordinator roles associated with the provide userId,    or for a specific country coordinator role if an actorKey is provided
   */
  fetchLicensingInternationalPayments(
    requestParameters: FetchLicensingInternationalPaymentsRequest
  ): Promise<FetchLicensingInternationalPaymentsResponse>

  /**
   *
   * @summary Fetch licensing community director payments for the userKey provided in the query parameters.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [userKey] Unique identifier for the user account.
   * @param {boolean} [generateReport] Flag to indicate if a record should be updated or created in jsonReportData table
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {string} [date] Filter licensing payments to those with a begunAt date greater than or equal to the given date.
   * @param {string} [program] Filter licensing payments by program type name (e.g., Foundations, Essentials, Challenge A).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchLicensingLcdPaymentsRaw(
    requestParameters: FetchLicensingLcdPaymentsRequest
  ): Promise<runtime.ApiResponse<FetchLicensingLcdPaymentsResponse>>

  /**
   * Fetch licensing community director payments for the userKey provided in the query parameters.
   */
  fetchLicensingLcdPayments(
    requestParameters: FetchLicensingLcdPaymentsRequest
  ): Promise<FetchLicensingLcdPaymentsResponse>

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * @summary List of all programs and enrollments that the user can create/edit payments for.
   * @param {number} userKey Unique identifier for the user account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  fetchPaymentOptionsRaw(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<runtime.ApiResponse<PaymentOptions>>

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * List of all programs and enrollments that the user can create/edit payments for.
   */
  fetchPaymentOptions(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<PaymentOptions>

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * @summary Pay via an ACH provider.
   * @param {number} paymentKey Unique identifier for a payment.
   * @param {PayByAchRequestBody} payByAchRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  payByAchRaw(
    requestParameters: PayByAchRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>>

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * Pay via an ACH provider.
   */
  payByAch(requestParameters: PayByAchRequest): Promise<PaymentResponse>

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * @summary Create a new payment for Enrollment or Licensing fees.
   * @param {PaymentStartRequestBody} paymentStartRequestBody
   * @param {number} [userKey] Unique identifier for the user account.
   * @param {boolean} [generateReport] Flag to indicate if a record should be updated or created in jsonReportData table
   * @param {number} [actorKey] Unique identifier for the actor.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  startPaymentRaw(
    requestParameters: StartPaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>>

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * Create a new payment for Enrollment or Licensing fees.
   */
  startPayment(requestParameters: StartPaymentRequest): Promise<PaymentResponse>

  /**
   *
   * @summary Updates an international licensing payment.
   * @param {number} paymentKey Unique identifier for the payment.
   * @param {Payment} [payment]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  updateLicensingInternationalPaymentRaw(
    requestParameters: UpdateLicensingInternationalPaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>>

  /**
   * Updates an international licensing payment.
   */
  updateLicensingInternationalPayment(
    requestParameters: UpdateLicensingInternationalPaymentRequest
  ): Promise<PaymentResponse>

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * @summary Update a payment for Enrollment or Licensing fees.
   * @param {Payment} [payment]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  updatePaymentRaw(
    requestParameters: UpdatePaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>>

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * Update a payment for Enrollment or Licensing fees.
   */
  updatePayment(
    requestParameters: UpdatePaymentRequest
  ): Promise<PaymentResponse>

  /**
   * This endpoint updates the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * @summary Update the billing address for an existing payment.
   * @param {number} paymentKey Unique identifier for a payment.
   * @param {Address} address
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  updatePaymentAddressRaw(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>>

  /**
   * This endpoint updates the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * Update the billing address for an existing payment.
   */
  updatePaymentAddress(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<PaymentResponse>

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * @summary Validates an ABA routing number.
   * @param {string} routingNumber The account routing number we are validating
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApiInterface
   */
  validateAchRoutingNumberRaw(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<runtime.ApiResponse<ValidateAchRoutingNumber>>

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * Validates an ABA routing number.
   */
  validateAchRoutingNumber(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<ValidateAchRoutingNumber>
}

/**
 *
 */
export class PaymentsApi
  extends runtime.BaseAPI
  implements PaymentsApiInterface
{
  /**
   * Adds a payment to the international licensing account for the the requested userKey
   * Adds a payment to the international licensing account for the the requested userKey
   */
  async addInternationalLicensingPaymentRaw(
    requestParameters: AddInternationalLicensingPaymentRequest
  ): Promise<runtime.ApiResponse<AddInternationalLicensingPaymentResponse>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling addInternationalLicensingPayment.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/internationalLicensingPayment`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AddInternationalLicensingPaymentRequestBodyToJSON(
        requestParameters.body
      ),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AddInternationalLicensingPaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * Adds a payment to the international licensing account for the the requested userKey
   * Adds a payment to the international licensing account for the the requested userKey
   */
  async addInternationalLicensingPayment(
    requestParameters: AddInternationalLicensingPaymentRequest
  ): Promise<AddInternationalLicensingPaymentResponse> {
    const response = await this.addInternationalLicensingPaymentRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * Delete a manually entered payment by paymentKey
   */
  async deletePaymentRaw(
    requestParameters: DeletePaymentRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling deletePayment.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   *        Delete manual payment for Enrollment or Licensing fees.       Requester must possess a Payment/deleteEnrollmentPayment grant or a deleteLicensingPayment grant in order to delete payments related to enrollment, else a 403 will be returned.
   * Delete a manually entered payment by paymentKey
   */
  async deletePayment(requestParameters: DeletePaymentRequest): Promise<void> {
    await this.deletePaymentRaw(requestParameters)
  }

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   */
  async fetchBillingRaw(
    requestParameters: FetchBillingRequest
  ): Promise<runtime.ApiResponse<FetchBillingResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.communityKey !== undefined) {
      queryParameters['communityKey'] = requestParameters.communityKey
    }

    if (requestParameters.programTypeKey !== undefined) {
      queryParameters['programTypeKey'] = requestParameters.programTypeKey
    }

    if (requestParameters.directorKey !== undefined) {
      queryParameters['directorKey'] = requestParameters.directorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/billing`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchBillingResponseFromJSON(jsonValue)
    )
  }

  /**
   * Calculates any licensing or enrollment payments owed. Returns those alongside payment transaction history.  Bills are identified by the `for` field. Enrollment payments are made for a set of student-in-program pairs; licensing payments are for a specific program.  An optional query parameter for `userKey` may be specified. The lack of this will return billing results for the current logged in requester. When adding the query parameter, billing results are returned for the specified userKey, given the requester has proper permissions.  ## PERMISSIONS: - The requester does not need any specific if no `userKey` query parameter is specified or the specified `userKey` matched the requester\'s userKey. - To view the billing info for anyone but the requesting user themselves requires permission both to view payments and to view the user in question. specifically:   - A Payment/view grant is required, else a 403 error will be returned.   - A User/view[their team\'s] grant will allow the requester to see the user\'s billing results if they are in the requester\'s downline team.   - A User/view[any] grant will allow the requester to see the billing results of any user in the system.
   * Get current enrollment and licensing bills and related transaction history in preparation for paying a bill
   */
  async fetchBilling(
    requestParameters?: FetchBillingRequest
  ): Promise<FetchBillingResponse> {
    const response = await this.fetchBillingRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Fetch licensing details for a requested program
   * Fetch licensing details for a requested program
   */
  async fetchCountryCoordinatorLicensingDetailsRaw(
    requestParameters: FetchCountryCoordinatorLicensingDetailsRequest
  ): Promise<
    runtime.ApiResponse<FetchCountryCoordinatorLicensingDetailsResponse>
  > {
    if (
      requestParameters.programKey === null ||
      requestParameters.programKey === undefined
    ) {
      throw new runtime.RequiredError(
        'programKey',
        'Required parameter requestParameters.programKey was null or undefined when calling fetchCountryCoordinatorLicensingDetails.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensingDetails/{programKey}`.replace(
        `{${'programKey'}}`,
        encodeURIComponent(String(requestParameters.programKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchCountryCoordinatorLicensingDetailsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch licensing details for a requested program
   * Fetch licensing details for a requested program
   */
  async fetchCountryCoordinatorLicensingDetails(
    requestParameters: FetchCountryCoordinatorLicensingDetailsRequest
  ): Promise<FetchCountryCoordinatorLicensingDetailsResponse> {
    const response = await this.fetchCountryCoordinatorLicensingDetailsRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Calculates the total balance owed by the current user acting as a Country Coordinator or the requester actorKey
   * Calculates the total balance owed by the Country Coordinator across all managed communities
   */
  async fetchCountryCoordinatorTotalBalanceRaw(
    requestParameters: FetchCountryCoordinatorTotalBalanceRequest
  ): Promise<runtime.ApiResponse<FetchCountryCoordinatorTotalBalanceResponse>> {
    const queryParameters: any = {}

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/country-coordinator-total-balance`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchCountryCoordinatorTotalBalanceResponseFromJSON(jsonValue)
    )
  }

  /**
   * Calculates the total balance owed by the current user acting as a Country Coordinator or the requester actorKey
   * Calculates the total balance owed by the Country Coordinator across all managed communities
   */
  async fetchCountryCoordinatorTotalBalance(
    requestParameters?: FetchCountryCoordinatorTotalBalanceRequest
  ): Promise<FetchCountryCoordinatorTotalBalanceResponse> {
    const response = await this.fetchCountryCoordinatorTotalBalanceRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * Returns the options needed for parents to complete paying their enrollment(s).
   */
  async fetchEnrollmentBillingPaymentOptionsRaw(
    requestParameters: FetchEnrollmentBillingPaymentOptionsRequest
  ): Promise<runtime.ApiResponse<OK>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/fetchEnrollmentBillingPaymentOptions`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OKFromJSON(jsonValue)
    )
  }

  /**
   * Returns the options needed for parents to complete paying their enrollment(s).     Only used for parents currently, if an actor calls this endpoint we will return an error.
   * Returns the options needed for parents to complete paying their enrollment(s).
   */
  async fetchEnrollmentBillingPaymentOptions(
    requestParameters?: FetchEnrollmentBillingPaymentOptionsRequest
  ): Promise<OK> {
    const response = await this.fetchEnrollmentBillingPaymentOptionsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Retrieve the available filter options to allow filter selection for the licensing billing endpoint.      At a minimum, the community or actors search values should be 3 characters. Provided params filter each response      by the name only.
   * Fetch filter options for licensing billing responses.
   */
  async fetchInternationalLicensingFilterOptionsRaw(
    requestParameters: FetchInternationalLicensingFilterOptionsRequest
  ): Promise<
    runtime.ApiResponse<FetchInternationalLicensingFilterOptionsResponse>
  > {
    if (
      requestParameters.actorKey === null ||
      requestParameters.actorKey === undefined
    ) {
      throw new runtime.RequiredError(
        'actorKey',
        'Required parameter requestParameters.actorKey was null or undefined when calling fetchInternationalLicensingFilterOptions.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.communityName !== undefined) {
      queryParameters['communityName'] = requestParameters.communityName
    }

    if (requestParameters.actorName !== undefined) {
      queryParameters['actorName'] = requestParameters.actorName
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensingFilterOptions`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchInternationalLicensingFilterOptionsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Retrieve the available filter options to allow filter selection for the licensing billing endpoint.      At a minimum, the community or actors search values should be 3 characters. Provided params filter each response      by the name only.
   * Fetch filter options for licensing billing responses.
   */
  async fetchInternationalLicensingFilterOptions(
    requestParameters: FetchInternationalLicensingFilterOptionsRequest
  ): Promise<FetchInternationalLicensingFilterOptionsResponse> {
    const response = await this.fetchInternationalLicensingFilterOptionsRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   *      This endpoint retrieves the total licensing balance and due amounts for all programs associated with the logged-in actor.     It provides a comprehensive summary of the current balance and due payments across the programs.
   * Fetch the total licensing balance and due amounts across programs for the logged in LCD.
   */
  async fetchLcdTotalOwedRaw(
    requestParameters: FetchLcdTotalOwedRequest
  ): Promise<runtime.ApiResponse<FetchLcdTotalOwedResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/lcdTotalOwed`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchLcdTotalOwedResponseFromJSON(jsonValue)
    )
  }

  /**
   *      This endpoint retrieves the total licensing balance and due amounts for all programs associated with the logged-in actor.     It provides a comprehensive summary of the current balance and due payments across the programs.
   * Fetch the total licensing balance and due amounts across programs for the logged in LCD.
   */
  async fetchLcdTotalOwed(
    requestParameters?: FetchLcdTotalOwedRequest
  ): Promise<FetchLcdTotalOwedResponse> {
    const response = await this.fetchLcdTotalOwedRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Fetch billing details for a licensed community director in a program
   * Fetch billing details for a licensed community director in a program
   */
  async fetchLicensedDirectorBillingDetailsRaw(
    requestParameters: FetchLicensedDirectorBillingDetailsRequest
  ): Promise<runtime.ApiResponse<FetchLicensedDirectorBillingDetailsResponse>> {
    if (
      requestParameters.programKey === null ||
      requestParameters.programKey === undefined
    ) {
      throw new runtime.RequiredError(
        'programKey',
        'Required parameter requestParameters.programKey was null or undefined when calling fetchLicensedDirectorBillingDetails.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.programKey !== undefined) {
      queryParameters['programKey'] = requestParameters.programKey
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensedDirectorBillingDetails`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchLicensedDirectorBillingDetailsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch billing details for a licensed community director in a program
   * Fetch billing details for a licensed community director in a program
   */
  async fetchLicensedDirectorBillingDetails(
    requestParameters: FetchLicensedDirectorBillingDetailsRequest
  ): Promise<FetchLicensedDirectorBillingDetailsResponse> {
    const response = await this.fetchLicensedDirectorBillingDetailsRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Fetch licensing international payments for all country coordinator roles associated with the provide userId,    or for a specific country coordinator role if an actorKey is provided
   */
  async fetchLicensingInternationalPaymentsRaw(
    requestParameters: FetchLicensingInternationalPaymentsRequest
  ): Promise<runtime.ApiResponse<FetchLicensingInternationalPaymentsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensingInternationalPayments`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchLicensingInternationalPaymentsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch licensing international payments for all country coordinator roles associated with the provide userId,    or for a specific country coordinator role if an actorKey is provided
   */
  async fetchLicensingInternationalPayments(
    requestParameters?: FetchLicensingInternationalPaymentsRequest
  ): Promise<FetchLicensingInternationalPaymentsResponse> {
    const response = await this.fetchLicensingInternationalPaymentsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Fetch licensing community director payments for the userKey provided in the query parameters.
   */
  async fetchLicensingLcdPaymentsRaw(
    requestParameters: FetchLicensingLcdPaymentsRequest
  ): Promise<runtime.ApiResponse<FetchLicensingLcdPaymentsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.date !== undefined) {
      queryParameters['date'] = requestParameters.date
    }

    if (requestParameters.program !== undefined) {
      queryParameters['program'] = requestParameters.program
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensingLcdPayments`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchLicensingLcdPaymentsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch licensing community director payments for the userKey provided in the query parameters.
   */
  async fetchLicensingLcdPayments(
    requestParameters?: FetchLicensingLcdPaymentsRequest
  ): Promise<FetchLicensingLcdPaymentsResponse> {
    const response = await this.fetchLicensingLcdPaymentsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * List of all programs and enrollments that the user can create/edit payments for.
   */
  async fetchPaymentOptionsRaw(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<runtime.ApiResponse<PaymentOptions>> {
    if (
      requestParameters.userKey === null ||
      requestParameters.userKey === undefined
    ) {
      throw new runtime.RequiredError(
        'userKey',
        'Required parameter requestParameters.userKey was null or undefined when calling fetchPaymentOptions.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/options/{userKey}`.replace(
        `{${'userKey'}}`,
        encodeURIComponent(String(requestParameters.userKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentOptionsFromJSON(jsonValue)
    )
  }

  /**
   * Provides a list of all programs user directs and list enrollments user has children enrolled in.       Takes a userKey in as a URL param.       Requires the user have updateEnrollmentPayment, updateLicensingPayment, view Program and view Enrollment grants.
   * List of all programs and enrollments that the user can create/edit payments for.
   */
  async fetchPaymentOptions(
    requestParameters: FetchPaymentOptionsRequest
  ): Promise<PaymentOptions> {
    const response = await this.fetchPaymentOptionsRaw(requestParameters)
    return await response.value()
  }

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * Pay via an ACH provider.
   */
  async payByAchRaw(
    requestParameters: PayByAchRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling payByAch.'
      )
    }

    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling payByAch.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}/ach`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: PayByAchRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * Pay via an ACH provider for a payment in WIP status. Will return the updated payment.  **NOTE:** Be sure to check the resulting `paymentStatus` to see if the payment was successful or not!
   * Pay via an ACH provider.
   */
  async payByAch(requestParameters: PayByAchRequest): Promise<PaymentResponse> {
    const response = await this.payByAchRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * Create a new payment for Enrollment or Licensing fees.
   */
  async startPaymentRaw(
    requestParameters: StartPaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling startPayment.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.userKey !== undefined) {
      queryParameters['userKey'] = requestParameters.userKey
    }

    if (requestParameters.generateReport !== undefined) {
      queryParameters['generateReport'] = requestParameters.generateReport
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: PaymentStartRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   *  Create a new payment for Enrollment or Licensing fees, or fees previously incurred due to NSF when making such a payment.   Enrollment payments are made for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided. Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  ## Without `userKey` Query Param (or `userKey === requester userKey`) When the the `userKey` query parameter is not utilized, the payment will be created for the current logged in user.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.  Payments can be made either by ACH or CC (credit card), specified in the `method` property. After validating inputs, will create and return a new WIP payment for either a licensing payment or enrollment payment.  For an Enrollment payment, an ACH discount will be applied to the total. The specified payment amount must match the enrollment bill total minus the ach discount amount, which is retrieved from the `fetchBilling` endpoint.  If the amount due for an enrollment payment is $0, then the newly created Payment will be set to PAID status, and the associated enrollments will be moved directly to ENROLLED status. When a payment is returned from the endpoint, and it is already in PAID status, no other steps of the payment flow will be necessary and a successful enrollment message should be shown to the user making the payment.  ## With `userKey` Query Param An optional query parameter for `userKey` is accepted to allow a user with proper permissions to create a new manually entered payment for another user. The amount provided for the payment can be any number. A negative number will be considered a credit on the user\'s account. A positive number will be considered a payment.  ## PERMISSIONS: - No specific permissions are required for the requester to make payments for their own account. - Requester must have a Payment/createLicensingPayment grant to create a licensing payment for another user. - Requester must have a Payment/createEnrollmentPayment grant to create an enrollment payment for another user.
   * Create a new payment for Enrollment or Licensing fees.
   */
  async startPayment(
    requestParameters: StartPaymentRequest
  ): Promise<PaymentResponse> {
    const response = await this.startPaymentRaw(requestParameters)
    return await response.value()
  }

  /**
   * Updates an international licensing payment.
   */
  async updateLicensingInternationalPaymentRaw(
    requestParameters: UpdateLicensingInternationalPaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling updateLicensingInternationalPayment.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/licensingInternationalPayments/{paymentKey}`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: PaymentToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * Updates an international licensing payment.
   */
  async updateLicensingInternationalPayment(
    requestParameters: UpdateLicensingInternationalPaymentRequest
  ): Promise<PaymentResponse> {
    const response = await this.updateLicensingInternationalPaymentRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * Update a payment for Enrollment or Licensing fees.
   */
  async updatePaymentRaw(
    requestParameters: UpdatePaymentRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: PaymentToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   *  EDit a payment for Enrollment or Licensing fees. After validating inputs, will create and return the updated payment for either a licensing payment or enrollment payment.    Enrollment payments are updated for a set of enrollments (student-in-program pairs), and paid for by parents to CC Home Office. A 400 will be returned if enrollments are not provided.  Licensing payments are made for a specific program, and paid for by directors to CC Home Office. A 400 will be returned if a programKey is not provided.  The amount provided for the payment must be greater than 0, but less than or equal to the total amount due, else a 400 error will be returned. An Enrollment payment must be the total amount due, else a 400 error will be returned.
   * Update a payment for Enrollment or Licensing fees.
   */
  async updatePayment(
    requestParameters?: UpdatePaymentRequest
  ): Promise<PaymentResponse> {
    const response = await this.updatePaymentRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * This endpoint updates the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * Update the billing address for an existing payment.
   */
  async updatePaymentAddressRaw(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<runtime.ApiResponse<PaymentResponse>> {
    if (
      requestParameters.paymentKey === null ||
      requestParameters.paymentKey === undefined
    ) {
      throw new runtime.RequiredError(
        'paymentKey',
        'Required parameter requestParameters.paymentKey was null or undefined when calling updatePaymentAddress.'
      )
    }

    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updatePaymentAddress.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payment/{paymentKey}/address`.replace(
        `{${'paymentKey'}}`,
        encodeURIComponent(String(requestParameters.paymentKey))
      ),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AddressToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PaymentResponseFromJSON(jsonValue)
    )
  }

  /**
   * This endpoint updates the billing address for an existing payment.  If the payment is for Enrollment, tax will be calculated from the provided address, updated on the payment record, and returned. Tax will be provided by a third-party service; if that service is unavailable, US addresses will have default state tax rates applied; if everything else fails, tax will be set to 0.  If the payment method is CC on the specified payment, a `ccFormToken` will be returned to be utilized for Authorize.net form iframe. See: https://developer.authorize.net/api/reference/index.html#accept-suite-get-an-accept-payment-page.
   * Update the billing address for an existing payment.
   */
  async updatePaymentAddress(
    requestParameters: UpdatePaymentAddressRequest
  ): Promise<PaymentResponse> {
    const response = await this.updatePaymentAddressRaw(requestParameters)
    return await response.value()
  }

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * Validates an ABA routing number.
   */
  async validateAchRoutingNumberRaw(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<runtime.ApiResponse<ValidateAchRoutingNumber>> {
    if (
      requestParameters.routingNumber === null ||
      requestParameters.routingNumber === undefined
    ) {
      throw new runtime.RequiredError(
        'routingNumber',
        'Required parameter requestParameters.routingNumber was null or undefined when calling validateAchRoutingNumber.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/payments/routingNumber/{routingNumber}`.replace(
        `{${'routingNumber'}}`,
        encodeURIComponent(String(requestParameters.routingNumber))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ValidateAchRoutingNumberFromJSON(jsonValue)
    )
  }

  /**
   * It will return 200 status code with a validRoutingNumber = true or false value respectively.   The endpoint validates if the account routing number is potentially correct by using a mathematical formula.   ABA routing numbers are always nine digits long. The first four specify the routing symbol, the next four identify    the institution and the last is the checksum digit.
   * Validates an ABA routing number.
   */
  async validateAchRoutingNumber(
    requestParameters: ValidateAchRoutingNumberRequest
  ): Promise<ValidateAchRoutingNumber> {
    const response = await this.validateAchRoutingNumberRaw(requestParameters)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchBillingProgramTypeKeyEnum {
  Foundations = 'Foundations',
  Scribblers = 'Scribblers',
  Essentials = 'Essentials',
  ChallengeA = 'Challenge A',
  ChallengeB = 'Challenge B',
  ChallengeI = 'Challenge I',
  ChallengeIi = 'Challenge II',
  ChallengeIii = 'Challenge III',
  ChallengeIv = 'Challenge IV',
}
